import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Register() {
  const [email, setEmail] = useState('');
  const [confirmEmail, setConfirmEmail] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();

    if (email !== confirmEmail) {
      setError('Emails do not match');
      return;
    }

    try {
      const response = await fetch('https://xcelitsolutions.co.uk/register.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (data.message === 'User registered successfully') {
        navigate('/tempLogin');
      } else {
        setError(data.message || 'Registration failed');
      }
    } catch (error) {
      setError('Error: ' + error.message);
    }
  };

  return (
    <div style={{ maxWidth: '400px', margin: 'auto', padding: '20px' }}>
      <h2>Register</h2>
      <form onSubmit={handleRegister}>
        <div>
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setError('');
            }}
            required
            style={{ width: '100%', marginBottom: '10px' }}
          />
        </div>
        <div>
          <label>Confirm Email</label>
          <input
            type="email"
            value={confirmEmail}
            onChange={(e) => {
              setConfirmEmail(e.target.value);
              setError('');
            }}
            required
            style={{ width: '100%', marginBottom: '10px' }}
          />
        </div>
        {error && (
          <div style={{ color: 'red', marginBottom: '10px' }}>{error}</div>
        )}
        <button type="submit" style={{ padding: '10px 20px' }}>Register</button>
      </form>
      <p style={{ marginTop: '15px' }}>
        Already have an account?{' '}
        <button
          onClick={() => navigate('/login')}
          style={{ color: 'blue', border: 'none', background: 'none', cursor: 'pointer' }}
        >
          Login here
        </button>
      </p>
    </div>
  );
}

export default Register;
